import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDHeadlineText, FDBodyText,
} from '@facet-wealth/design';
import { withComponentArray } from 'Helpers/MetaOverride';


export default buildFacetDesignOverride()

  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'md',
    },
  }, overrideReadOnly)
  .nameOverride('body', {
    _component: () => withComponentArray(FDBodyText),
  }, overrideReadOnly);
